<template>
  <section class="page-section">
        <el-tabs v-model="tabName" type="card" @tab-click="handleTabsChange">
          <el-tab-pane label="兑换中" name="1"></el-tab-pane>
          <el-tab-pane label="已兑完" name="2"></el-tab-pane>
          <el-tab-pane label="仓库中" name="0"></el-tab-pane>
        </el-tabs>
        <!-- filter -->
        <div class="filter-region">
          <div class="filter-form">
            <el-form size="small" :inline="true" :model="filterForm" ref="filterForm">
              <el-form-item label="商品/项目：" prop="name">
                <el-input v-model="filterForm.name" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="积分范围：" prop="pointType">
                <el-select filterable v-model="filterForm.pointType" placeholder="请选择">
                  <el-option v-for="item in pointTypeOptions" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="tabName == '1' ? '上架时间：' : tabName == '2' ? '下架时间：' : '最后编辑时间：'" prop="time"
                class="auto-width">
                <el-date-picker v-model="filterForm.time" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
                  start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
            </el-form>
          </div>
          <div class="filter-btn">
            <el-button-group class="btn-group">
              <el-button plain class="btn-reset" icon="el-icon-refresh"
                @click="filterFormReset('filterForm')"></el-button>
              <el-button type="primary" class="btn-search" @click="filterFormSubmit('filterForm')"
                :loading="tableLoading">查询</el-button>
            </el-button-group>
          </div>
        </div>

        <el-button type="primary" class="btn-add-block" @click="pageNavigateToGoodsManageAdd(null)">发布积分商品</el-button>

        <!-- table -->
        <div class="table-region" v-loading="tableLoading">
          <el-table size="small" :data="tableData" ref="multipleTable" @selection-change="handleTableSelectionChange">
            <el-table-column type="selection" width="42"></el-table-column>
            <el-table-column label="商品/项目" width="200">
              <template slot-scope="scope">
                <div class="goods-title">
                  <div class="thumb-wrap">
                    <img :src="scope.row.pic">
                  </div>
                  <p v-if="scope.row.type === 0 || scope.row.type === 2">{{ scope.row.code }}</p>
                  <p>{{ scope.row.name }}</p>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="规格/单位">
              <template slot-scope="scope">
                <template v-if="scope.row.type === 0 || scope.row.type === 2">
                  <p v-for="(record, recordIndex) in scope.row.skuList" :key="recordIndex"
                    style="white-space: nowrap;overflow:hidden;text-overflow:ellipsis;">
                    {{ record.firstValue }} {{ record.secondValue }} {{ record.thirdValue }}
                  </p>
                </template>
                <template v-if="scope.row.type === 1">
                  <p>{{ scope.row.unit }}</p>
                </template>
              </template>
            </el-table-column>
            <el-table-column label="积分" sortable sort-by="points">
              <template slot-scope="scope">
                <p>
                  {{ scope.row.points }}&nbsp;
                  <!-- 积分 -->
                  <el-popover placement="top" width="auto" v-model="scope.row.editPointsVisible"
                    popper-class="confirm-popover" @show="handleEdit(scope.row.id)" v-if="!tableLoading">
                    <el-input type="number" v-model="scope.row.points"></el-input>
                    <div>
                      <el-button size="small" type="default" plain
                        @click="scope.row.editPointsVisible = false">取消</el-button>
                      <el-button size="small" type="primary" @click="handlePointsSaveEdit(scope.row)"
                        :loading="operateLoading">确定</el-button>
                    </div>
                    <el-button size="small" type="text" icon="el-icon-edit" slot="reference"
                      class="button-edit"></el-button>
                  </el-popover>
                </p>
              </template>
            </el-table-column>
            <el-table-column label="库存" sortable sort-by="stock">
              <template slot-scope="scope">
                <div style="display: flex; flex-direction: row; align-items: center;">
                  <p>
                    {{ scope.row.stock }}&nbsp;
                    <!-- 库存 -->
                    <el-popover placement="top" width="auto" v-model="scope.row.editStockVisible"
                      popper-class="confirm-popover" @show="handleEdit(scope.row.id)" v-if="!tableLoading">
                      <el-input type="number" v-model="scope.row.stock"></el-input>
                      <div>
                        <el-button size="small" type="default" plain
                          @click="scope.row.editStockVisible = false">取消</el-button>
                        <el-button size="small" type="primary" @click="handleStockSaveEdit(scope.row)"
                          :loading="operateLoading">确定</el-button>
                      </div>
                      <el-button size="small" type="text" icon="el-icon-edit" slot="reference"
                        class="button-edit"></el-button>
                    </el-popover>
                  </p>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="总兑换" sortable sort-by="sale">
              <template slot-scope="scope">
                <p>{{ scope.row.exchangeNum > 0 ? scope.row.exchangeNum : '-' }}</p>
              </template>
            </el-table-column>
            <el-table-column :label="tabName == '1' ? '上架时间' : tabName == '2' ? '下架时间' : '最后编辑时间'" sortable
              sort-by="createDate">
              <template slot-scope="scope">
                <p v-if="tabName == '1'">{{ COMMON.formatDate('2', '-', scope.row.lastUpdateDate) }}</p>
                <p v-if="tabName == '2'">{{ COMMON.formatDate('2', '-', scope.row.lastUpdateDate) }}</p>
                <p v-if="tabName == '0'">{{ COMMON.formatDate('2', '-', scope.row.lastUpdateDate) }}</p>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="right">
              <template slot-scope="scope">
                <el-button size="small" type="text" @click="pageNavigateToGoodsManageAdd(scope.row)">编辑</el-button>
                <el-button v-if="tabName == '1'" size="small" type="text" @click="handleSort(scope.row)">{{
                  scope.row.isTop == 1 ? '取消置顶' : '置顶' }}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="table-footer" v-if="page.total > 0">
          <div class="selection-operate">
            <el-checkbox v-model="allSelect" @change="handleAllSelectChange">全选当页</el-checkbox>
            <div class="button-wrap">
              <!-- 上架 -->
              <el-popover placement="top" width="165" v-model="operate.upVisible" popper-class="confirm-popover"
                v-if="tabName == 0">
                <p>上架后,可在"销售中"查看该商品，确定上架？</p>
                <div>
                  <el-button size="small" type="default" plain @click="handleOperateCancle">取消</el-button>
                  <el-button size="small" type="primary" @click="handleUpdateStatus(1)"
                    :loading="operateLoading">确定</el-button>
                </div>
                <el-button size="small" type="default" plain slot="reference">上架</el-button>
              </el-popover>
              <!-- 下架 -->
              <el-popover placement="top" width="165" v-model="operate.downVisible" popper-class="confirm-popover"
                v-if="tabName == 1">
                <p>下架后，可在"仓库中"查看该商品，确定下架？</p>
                <div>
                  <el-button size="small" type="default" plain @click="handleOperateCancle">取消</el-button>
                  <el-button size="small" type="primary" @click="handleUpdateStatus(0)"
                    :loading="operateLoading">确定</el-button>
                </div>
                <el-button size="small" type="default" plain slot="reference">下架</el-button>
              </el-popover>
              <!-- 删除 -->
              <el-popover placement="top" width="165" v-model="operate.deleteVisible" popper-class="confirm-popover">
                <p>确定删除该商品？</p>
                <div>
                  <el-button size="small" type="default" plain @click="handleOperateCancle">取消</el-button>
                  <el-button size="small" type="primary" @click="handleUpdateStatus(3)"
                    :loading="operateLoading">确定</el-button>
                </div>
                <el-button size="small" type="default" plain slot="reference">删除</el-button>
              </el-popover>
            </div>
          </div>
          <div class="pagination-wrap">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :page-sizes="[20, 50, 100]" :pager-count="5" :current-page="page.current" :page-size="page.size"
              layout="total, sizes, prev, pager, next, jumper" :total="page.total">
            </el-pagination>
          </div>
        </div>
      </section>
</template>

<script>
import { commodityList, commodityCategoryList, commodityUpdateStatus, commodityListSku, commodityListUpdateSku, commodityCategoryLabelList, validGoodsList, commodityFilterOptions } from '@/common/api'
import { COMMON, pointsList, pointsUpdateStatus, pointsUpdateStock, pointsUpdatePoints, pointsSetTop } from '@/common/api'

export default {
  name: 'goodsManageList',
  data() {
    return {
      COMMON,
      tabName: '1', //选项卡name
      filterForm: { //筛选表单值
        name: '', // 商品名
        pointType: 0,
        time: []
      },
      pointTypeOptions: [
        {
          id: 0,
          name: '不限'
        },
        {
          id: 1,
          name: '1-1000'
        },
        {
          id: 2,
          name: '1001-5000'
        },
        {
          id: 3,
          name: '5001-10000'
        },
        {
          id: 4,
          name: '10001以上'
        }
      ], // 下拉列表
      moduleOptions: [], // 关键词下拉列表
      tableLoading: true,
      tableData: [], //表格数据
      page: {
        current: 1,
        size: 20,
        total: 0
      },
      multipleSelection: [], // 选中的数据
      allSelect: false, //全选当页
      operate: {
        upVisible: false, // 上架
        downVisible: false, // 下架
        deleteVisible: false // 删除
      },
      operateLoading: false,
      specification: {
        list: [], // 规格列表
        particularData: [] // 规格明细列表
      },
      specificationLoading: false,
      tableHeight: 400
    }
  },
  computed: {
    getCategoryLabel(category, type) {
      return function (category, type) {
        let label = ''
        if (category && category[0]) {
          let arr = category[0].split(',')
          if (type == 1) {
            return arr[0]
          } else if (type == 2) {
            return arr[1]
          }
        }
        return label
      }
    }
  },
  methods: {
    /**
     * [handleFilterGoodsNameSuggestions description] 商品名字联想
     * @param  {[type]}   query [description]
     * @param  {Function} cb    [description]
     * @return {[type]}         [description]
     */
    handleFilterGoodsNameSuggestions: function (query, cb) {
      let list = this.nameSuggestionsOptions;
      let results = query ? list.filter(this.createFilter(query)) : list;
      cb(results);
    },
    createFilter(query) {
      return (item) => {
        return (item.value.toLowerCase().indexOf(query.toLowerCase()) === 0);
      };
    },
    /**
     * [handleTabsChange description] 切换选项卡
     * @param  {[type]} tab   [description] 取name值用tab.name
     * @param  {[type]} event [description]
     * @return {[type]}       [description]
     */
    handleTabsChange: function (tab, event) {
      // 初始化状态
      this.filterForm = {
        name: '',
        pointType: 0,
        time: []
      };
      this.page.current = 1;
      this.multipleSelection = [];
      this.allSelect = false;
      this.handleOperateCancle();
      this.getList();
    },
    /**
     * [getList description] 获取表格数据
     * @return {[type]} [description]
     */
    getList: function () {
      this.tableLoading = true;
      let time = this.filterForm.time
      let params = {
        status: parseFloat(this.tabName),
        name: this.filterForm.name,
        pointType: this.filterForm.pointType || 0,
        // moduleId: this.filterForm.moduleId || null,
        // deliverFeeType: this.filterForm.deliverFeeType || null,
        // templateId: this.filterForm.templateId || null,
        // marketingType: this.filterForm.marketingType || null,
        // marketingId: this.filterForm.marketingId || null,
        startTime: time && time.length > 1 ? new Date(time[0]).getTime() : null,
        endTime: time && time.length > 1 ? (new Date(time[1]).getTime() + 24 * 60 * 60 * 1000 - 1) : null,
        current: this.page.current,
        size: this.page.size
      }
      pointsList(params).then(res => {
        this.tableLoading = false;
        let { code, data, msg } = res;
        if (code == 0) {
          let dataArray = data.records || [];
          if (dataArray && dataArray.length > 0) {
            dataArray.map(row => {
            })
          }
          this.tableData = dataArray;
          this.page.total = data.total;
          this.$nextTick(() => {
            const scrollContainer = document.querySelector('.app-container');
            if (scrollContainer) {
              scrollContainer.scrollTop = 0;
            }
          });
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.$message.error('服务器异常');
      });
    },
    /**
     * [handleSizeChange description] 分页每页条数变化
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleSizeChange(val) {
      this.page.current = 1;
      this.page.size = val;
      this.getList();
    },
    /**
     * [handleCurrentChange description] 选择分页第几页
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleCurrentChange(val) {
      this.page.current = val;
      this.getList();
    },
    /**
     * [filterFormSubmit description] 提交筛选表单
     * @param  {[type]} formName [description]
     * @return {[type]}          [description]
     */
    filterFormSubmit: function (formName) {
      this.page.current = 1;
      this.getList();
    },
    /**
     * [filterFormReset description] 重置筛选表单
     * @param  {[type]} formName [description]
     * @return {[type]}          [description]
     */
    filterFormReset: function (formName) {
      this.$refs[formName].resetFields();
      this.secondCategoryOptions = [];
    },
    /**
     * [handleTableSelectionChange description] table筛选选中状态变化
     * @param  {[type]} val [description] 选中行的数据集合array
     * @return {[type]}     [description]
     */
    handleTableSelectionChange: function (val) {
      if (val.length < this.tableData.length) {
        // 未全选中，改变底部全选状态
        this.allSelect = false;
      } else {
        this.allSelect = true;
      }
      this.multipleSelection = val;
    },
    /**
     * [handleAllSelectChange description] 全选
     * @param  {[type]} selected [description]
     * @return {[type]}          [description]
     */
    handleAllSelectChange: function (selected) {
      this.$refs.multipleTable.toggleAllSelection();
    },
    /**
     * [handleOperateCancle description] 操作popover - 取消
     * @return {[type]} [description]
     */
    handleOperateCancle: function () {
      this.operate = {
        upVisible: false,
        downVisible: false,
        deleteVisible: false
      }
    },
    /**
     * [handleUpdateStatus description] 商品上下架、删除
     * @param  {[type]} status [description]
     * @return {[type]}        [description]
     */
    handleUpdateStatus: function (status) {
      let statusName = '';
      if (status == 1) {
        statusName = '上架';
      } else if (status == 0) {
        statusName = '下架';
      } else if (status == 3) {
        statusName = '删除';
      }
      if (this.multipleSelection.length == 0) {
        this.$message.error('请选择需要' + statusName + '的商品/项目');
        this.handleOperateCancle();
        return false;
      }
      this.operateLoading = true;
      let ids = [];
      for (let i = 0; i < this.multipleSelection.length; i++) {
        ids.push(this.multipleSelection[i].id);
      }
      let params = {
        ids: ids.join(','),
        status: status
      }
      pointsUpdateStatus(params).then(res => {
        this.operateLoading = false;
        let { code, data, msg } = res;
        if (code == 0) {
          this.$message({ message: statusName + '成功', type: 'success' });
          this.multipleSelection = [];
          this.handleOperateCancle();
          this.getList();
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.operateLoading = false;
        this.$message.error('服务器异常');
      });
    },
    /**
     * [pageNavigateToGoodsManageAdd description] 跳转到发布商品页面
     * @return {[type]} [description]
     */
    pageNavigateToGoodsManageAdd: function (row) {
      if (row) {
        this.$router.push({ path: '/marketing/points/add', query: { id: row.itemId, pointId: row.id, pointType: row.type } });
      } else {
        this.$router.push({ path: '/marketing/points/add' });
      }
    },
    /**
     * [handleEdit description] 编辑价格或库存
     * @param  {[type]} id [description]
     * @return {[type]}    [description]
     */
    handleEdit: function (id) {
      // this.specification = {
      //     list: [],
      //     particularData: []
      // }                
      // this.getSpecificationList(id)
    },
    /**
     * [getSpecificationList description] 获取规格和规格明细
     * @param  {[type]} id [description]
     * @return {[type]}    [description]
     */
    getSpecificationList: function (id) {
      this.specificationLoading = true;
      let params = {
        id: id
      }
      commodityListSku(params).then(res => {
        this.specificationLoading = false;
        let { code, data, msg } = res;
        if (code == 0) {
          this.specification = {
            list: data.specificationList || [],
            particularData: data.specificationDetailList || []
          }
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.$message.error('服务器异常');
      });
    },
    /**
     * [handlePointsSaveEdit description] 积分保存编辑
     * @return {[type]} [description]
     */
    handlePointsSaveEdit: function (record) {
      this.operateLoading = true;
      let params = {
        id: record.id,
        points: record.points
      }
      pointsUpdatePoints(params).then(res => {
        this.operateLoading = false;
        let { code, data, msg } = res;
        if (code == 0) {
          this.$message({ message: '保存成功', type: 'success' });
          this.getList();
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.operateLoading = false;
        this.$message.error('服务器异常');
      });
    },
    /**
     * [handleStockSaveEdit description] 库存保存编辑
     * @return {[type]} [description]
     */
    handleStockSaveEdit: function (record) {
      this.operateLoading = true;
      let params = {
        id: record.id,
        stock: record.stock
      }
      pointsUpdateStock(params).then(res => {
        this.operateLoading = false;
        let { code, data, msg } = res;
        if (code == 0) {
          this.$message({ message: '保存成功', type: 'success' });
          this.getList();
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.operateLoading = false;
        this.$message.error('服务器异常');
      });
    },
    /**
     * [handleParticularTableRowMethod description] 合并规格明细表格中相同的规格名
     * @param  {[type]} options.row         [description]
     * @param  {[type]} options.column      [description]
     * @param  {[type]} options.rowIndex    [description]
     * @param  {[type]} options.columnIndex [description]
     * @return {[type]}                     [description]
     */
    handleParticularTableRowMethod: function ({ row, column, rowIndex, columnIndex }) {
      let specificationList = this.specification.list,
        particularData = [],
        firstLen = this.handleGetSpecificationValuesLenthMethod(0) || 1,
        secondLen = this.handleGetSpecificationValuesLenthMethod(1) || 1,
        thirdLen = this.handleGetSpecificationValuesLenthMethod(2) || 1;
      if (specificationList[0] && specificationList[0].valueNameList.length > 0 && columnIndex === 0) {
        if (rowIndex % (secondLen * thirdLen) === 0) {
          return {
            rowspan: secondLen * thirdLen,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
      if (specificationList[1] && specificationList[1].valueNameList.length > 0 && columnIndex === 1) {
        if (rowIndex % thirdLen === 0) {
          return {
            rowspan: thirdLen,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    /**
     * [handleGetSpecificationValuesLenthMethod description] 获取各个规格名下规格值不为空的规格值长度
     * @param  {[type]} index [description] 规格名的索引
     * @return {[type]}       [description]
     */
    handleGetSpecificationValuesLenthMethod: function (index) {
      let specificationList = this.specification.list,
        item = specificationList[index],
        len = 0;
      if (item && item.valueNameList.length > 0) {
        for (let i = 0; i < item.valueNameList.length; i++) {
          if (item.valueNameList[i].name) {
            len += 1;
          }
        }
      }
      return len;
    },
    /**
     * [handleSort description] 置顶、取消置顶
     * @return {[type]} [description]
     */
    handleSort: function (row) {
      let params = {
        id: row.id,
        status: row.isTop === 1 ? 0 : 1
      }
      pointsSetTop(params).then(res => {
        let { code, data, msg } = res;

        if (code == 0) {
          this.$message({ message: '操作成功', type: 'success' });
          this.getList();
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.$message.error('服务器异常');
      });
    },
    /**
     * [calcTableHeight description] 动态计算表格高度
     * @return {[type]} [description]
     */
    // calcTableHeight() {
    //   const tableRegion = document.querySelector('.table-region')
    //   const tableFooter = document.querySelector('.table-footer')
    //   if (tableRegion) {
    //     const regionHeight = tableRegion.clientHeight
    //     const footerHeight = tableFooter ? tableFooter.offsetHeight : 0
    //     // 减去上下间距
    //     this.tableHeight = regionHeight - footerHeight - 20
    //     this.$nextTick(() => {
    //       this.$refs.multipleTable && this.$refs.multipleTable.doLayout()
    //     })
    //   }
    // }
  },
  mounted() {
    this.getList();
    // this.$nextTick(() => {
    //   this.calcTableHeight()
    // })
    // window.addEventListener('resize', this.calcTableHeight)
  },
  beforeDestroy() {
    // window.removeEventListener('resize', this.calcTableHeight)
  }
}
</script>

<style lang="scss" scoped>
@import "../../../common/styles/base/mixin-font";
@import "../../../common/styles/base/mixin-common";

// .page-container {
//   height: 100%;
// }

// .page-main {
//   flex: 1;
//   overflow: hidden;
//   display: flex;
//   flex-direction: column;
// }

// .page-section {
//   display: flex;
//   flex-direction: column;
//   flex: 1;
//   overflow: hidden;

//   >.el-tabs {
//     flex-shrink: 0;
//   }

//   .btn-add-block {
//     flex-shrink: 0;
//     align-self: flex-start;
//   }
// }

.filter-region {
  // flex-shrink: 0; // 筛选区域不压缩
  display: flex;
  align-items: center;

  .filter-form {
    flex: 1;
  }

  .filter-btn {
    height: 100%;

    .btn-group {
      display: flex;

      .btn-reset {
        width: 40px;
        height: 40px;
        border-color: #3388ff;
        color: #3388ff;
      }

      .btn-search {
        width: 84px;
        height: 40px;
      }

      .el-button {
        &+.el-button {
          margin-left: -1px !important;
        }

        &:first-child {
          border-top-right-radius: 0 !important;
          border-bottom-right-radius: 0 !important;
        }

        &:last-child {
          border-top-left-radius: 0 !important;
          border-bottom-left-radius: 0 !important;
        }
      }
    }
  }
}

.table-region {
  // flex: 1; // 占用剩余高度
  // display: flex;
  // flex-direction: column;
  // overflow: hidden;
  margin-bottom: 50px;

  ::v-deep .el-table {
    // flex: 1;

    &::before {
      height: 0;
    }

  }

  // 修复固定列头部背景色不一致问题
  ::v-deep .el-table__fixed-right-patch {
    background-color: #f6f7f9; // $colorTitleBg 的值，或者直接写变量如果可用
    border-bottom: none;
  }

  ::v-deep .el-table__fixed-right {
    thead th {
      background-color: #f6f7f9;
      border-bottom: none;
    }

    &::before {
      height: 0;
    }
  }

  // .table-footer {
  //   flex-shrink: 0; // 分页区域不压缩，保持固定高度
  // }
}

.goods-title {
  position: relative;
  padding-left: 58px;
  min-height: 48px;

  .thumb-wrap {
    @include position(absolute, 3, 50%, none, none, 0);
    width: 48px;
    height: 48px;
    margin-top: -24px;
    background-color: $colorPageBg;

    img {
      max-width: 100%;
      max-height: 100%;
      @include position(absolute, 1, 50%, none, none, 50%);
      @include translate(-50%, -50%, 0);
    }
  }

  p {
    line-height: 1.4;

    &+p {
      margin-top: 5px;
    }
  }
}

.button-edit {
  display: none;
}

.el-table__row {
  &:hover {
    .button-edit {
      display: inline-block;
      padding-top: 0;
      padding-bottom: 0;
    }
  }
}

.paticular-table {
  margin-top: 0;
  background-color: transparent;

  &::before {
    display: none;
  }

  .el-table__header-wrapper {}

  ::v-deep .el-table__body-wrapper {
    .el-table__body {
      .el-table__row {
        background-color: transparent;

        td {
          padding: 5px 0;
          border-bottom-color: #ebeef5;
          /*border-bottom-color: transparent;*/
        }
      }
    }
  }
}
</style>
